export const STANDARD = [
  {
    products:
      "ASTM F963-23, Standard Consumer Safety Specification for Toy Safety",
    law: "CPSIA",
    section: "16 CFR Part 1250",
  },
  {
    products:
      "CPSIA Section 101(a)(2), Total Lead Content in Substrate Materials",
    law: "CPSIA",
    section: "CPSIA Section 101(a)(2)",
  },
  {
    products: "CPSIA Section 108, Phthalates Content",
    law: "CPSIA",
    section: "CPSIA Section 108",
  },
  {
    products: "16 CFR Part 1500, Federal Hazardous Substances Act (FHSA)",
    law: "FHSA",
    section: "16 CFR Part 1500",
  },
  {
    products: "16 CFR 1500.44, Flammable Solids",
    law: "FHSA",
    section: "16 CFR 1500.44",
  },
  {
    products: "CPSIA Section 103, Tracking Labels for Children’s Products",
    law: "CPSIA",
    section: "CPSIA Section 103",
  },
];
